<!DOCTYPE html>
<html lang="en">
<!--
      88888888ba,    88               88
      88      `"8b   ""               ""    ,d
      88        `8b                         88
      88         88  88   ,adPPYb,d8  88  MM88MMM  ,adPPYba,
      88         88  88  a8"    `Y88  88    88     I8[    ""
      88         8P  88  8b       88  88    88      `"Y8ba,
      88      .a8P   88  "8a,   ,d88  88    88,    aa    ]8I
      88888888Y"'    88   `"YbbdP"Y8  88    "Y888  `"YbbdP"'
                          aa,    ,88
                          "Y8bbdP"
   -->
<head>
    <meta charset="UTF-8" />
    <meta name="robots" content="noindex" />
    <meta name="color-scheme" content="light" />

    <!-- Primary Meta Tags -->
    <meta name="title" content="Digits - Get AI Accounting">
    <meta name="description" content="Experience the first end-to-end accounting platform of the AI era.">

    <!-- Open Graph / Facebook -->
    <meta property="og:type" content="website">
    <meta property="og:url" content="https://digits.com/">
    <meta property="og:title" content="Digits - Get AI Accounting">
    <meta property="og:description" content="Experience the first end-to-end accounting platform of the AI era.">
    <meta property="og:image" content="https://digits.com/_assets/og-images/digits-general-og-image.png">
    <meta property="og:image:width" content="1200">
    <meta property="og:image:height" content="630">

    <!-- Twitter -->
    <meta property="twitter:card" content="summary_large_image">
    <meta property="twitter:url" content="https://digits.com/">
    <meta property="twitter:title" content="Digits - Get AI Accounting">
    <meta property="twitter:description" content="Experience the first end-to-end accounting platform of the AI era.">
    <meta property="twitter:image" content="https://digits.com/_assets/og-images/digits-general-og-image.png">

    <title><%= process.env.TITLE %></title>
</head>
<body>
    <main id="main"></main>
<% if (env.MOCKS)  { %>
    <script type="module" src="/mockClient.tsx"></script>
<% } else  { %>
    <script type="module" src="/client.tsx"></script>
<% } %>
</body>
</html>
